import { useOrganizationCapabilities } from "../capability/useOrganizationCapabilities";
import { usePlatformCapabilities } from "../capability/usePlatformCapabilities";

/**
 * Whether the current user is a member of the current platform / organization
 * scope — i.e. holds **any** capability on it. This is the pure-RBAC form of the
 * former owner/manager/admin context-membership predicate: after the strict
 * cutover the S0 grant materialisation gives every legacy member (federation
 * owner, platform/org manager, admin) a non-empty capability set on their scope,
 * while a non-member resolves to an empty set. It intentionally spans both the
 * platform and the organization node (a platform manager is a member without an
 * org-node grant; an org owner is a member without a platform-node grant).
 *
 * Reserved for the surfaces that have **no capability key of their own** and must
 * stay visible to scope members after the cutover (the read-open news/gallery nav
 * items, the header create button). Surfaces that own a specific key gate on that
 * key directly and must NOT OR-bridge this predicate — that would widen access
 * back to every member.
 */
export const useCanSeeOrganizationData = (): boolean => {
  const platformCapabilities = usePlatformCapabilities();
  const organizationCapabilities = useOrganizationCapabilities();

  return platformCapabilities.size > 0 || organizationCapabilities.size > 0;
};
